module.exports = __webpack_public_path__ + "img/bigscoot.8aff433f.png";